

export const replaceNameCategory = (name: string) => {
    const labelToSwitch = {
        Actu: "Type d'actualité",
        Principale: "Métier SDM",
        Document: "Type de document",
        Produit: "Catégorie produit MIF",
        Focus: "Focus Actu",
        Hebdo: "Hebdo Eco",
        Perspectives: "Perspectives Eco",
        Points: "Tendances Marché",
        "PME dette": "Flash Taux",
        "PME placement": "Flash Placement",
        "PME change": "Flash Change",
        "PME Dette": "Flash Taux",
        "PME Placement": "Flash Placement",
        "PME Change": "Flash Change",
        Dette: "Taux",
        dette: "taux"
    }
    return labelToSwitch[name] ? labelToSwitch[name] : name
}


// WEBPACK FOOTER //
// ./src/shared/CategoriesFilter/helpers.ts